export default "__VITE_ASSET__e8af5fe7__"